import { Formik } from "formik";
import moment from "moment";
import React from "react";
import { FormControl } from "@mui/material";
import { DatePicker } from "rsuite";
import { useSelector } from "react-redux";

const TransactionFilterByDate = (props) => {
  const selectedPlace = useSelector((state) => state.places?.selectedPlace);
  const placeId = selectedPlace?._id;
  const { filterOptions, setFilterOptions } = props;

  return (
    <>
      <Formik
        initialValues={{
          startDate: "",
          endDate: "",
        }}
        onSubmit={(values) => {
          setFilterOptions({
            ...filterOptions,
            pageNo: 0,
            ...values,
            placeId,
            tz: selectedPlace?.timeZoneId,
            startDate: moment(values.startDate).format("YYYY-MM-DD").toString(),
            endDate: moment(values.endDate).format("YYYY-MM-DD").toString(),
          });
        }}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <FormControl fullWidth>
              <div style={{ display: "flex", gap: "1rem" }}>
                <DatePicker
                  id="startDate"
                  placeholder="Start Date"
                  size="lg"
                  format="dd/MM/yyyy"
                  ranges={[]}
                  value={
                    props.values.startDate
                      ? new Date(props.values.startDate)
                      : null
                  }
                  onChange={(value) => {
                    props.setFieldValue(
                      "startDate",
                      value ? moment(value).format() : null
                    );
                    if (!value) {
                      props.setFieldValue("endDate", null);
                      setFilterOptions({
                        status: "all",
                        placeId,
                        startDate: "",
                        endDate: "",
                        search: "",
                      });
                    }
                  }}
                  onOk={props.handleSubmit}
                  onClean={() => {
                    props.setFieldValue("startDate", null);
                    props.setFieldValue("endDate", null);
                    setFilterOptions({
                      status: "all",
                      placeId,
                      startDate: "",
                      endDate: "",
                      search: "",
                    });
                  }}
                />
                <DatePicker
                  id="endDate"
                  placeholder="End Date"
                  size="lg"
                  format="dd/MM/yyyy"
                  ranges={[]}
                  value={
                    props.values.endDate ? new Date(props.values.endDate) : null
                  }
                  onChange={(value) => {
                    props.setFieldValue(
                      "endDate",
                      value ? moment(value).format() : null
                    );
                    if (!value) {
                      props.setFieldValue("startDate", null);
                      setFilterOptions({
                        status: "all",
                        placeId,
                        startDate: "",
                        endDate: "",
                        search: "",
                      });
                    }
                  }}
                  onOk={props.handleSubmit}
                  onClean={() => {
                    props.setFieldValue("startDate", null);
                    props.setFieldValue("endDate", null);
                    setFilterOptions({
                      status: "all",
                      placeId,
                      startDate: "",
                      endDate: "",
                      search: "",
                    });
                  }}
                  disabled={!props.values.startDate}
                />
              </div>
            </FormControl>
          </form>
        )}
      </Formik>
    </>
  );
};

export default TransactionFilterByDate;
